import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "css-variables"
    }}>{`CSS Variables`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{` UXP v3.0`}</p>
    <p>{`UXP supports the use of CSS Variables, otherwise known as Custom Properties. This feature, combined with support for the `}<a parentName="p" {...{
        "href": "../../Media%20Queries/prefers-color-scheme/"
      }}>{`prefers-color-scheme`}</a>{` media query makes it extremely easy to create custom themes that respond to the selected theme in the host application.`}</p>
    <p><strong parentName="p">{`See:`}</strong>{` `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/CSS/--"
      }}>{`https://developer.mozilla.org/en-US/docs/Web/CSS/--`}</a>{`*`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      